export default "__VITE_ASSET__suH66VgN__"